import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3eaa3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status-modal-title" }
const _hoisted_2 = { class: "text-gray-600 text-sm" }

import { computed } from 'vue'
import LingoModalComponent from '@/modules/main/components/manage/LingoModalComponent.vue'
import { getStatusMetadata } from '@/utils/statusUtils'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusDetailModal',
  props: {
    isOpen: { type: Boolean },
    lastOnline: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;





const status = computed(() => getStatusMetadata(props.lastOnline))

function close() {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LingoModalComponent, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": close,
    size: "sm",
    centered: "",
    showCloseButton: true
  }, {
    header: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(status.value.label), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        onClick: close,
        class: "status-modal-close-btn"
      }, " Close ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, " Last online: " + _toDisplayString(status.value.timeAgo) + ". ", 1)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})